const { createSelector } = require('reselect')

const selectPartnerList = state => state.partnerDomain.partnerList

const getPartnerList = () => createSelector(
  [selectPartnerList],
  cse => cse.data,
)

const getPartnerListError = () => createSelector(
  [selectPartnerList],
  cse => cse.error,
)

const getPartnerListLoading = () => createSelector(
  [selectPartnerList],
  cse => cse.loading,
)

const selectPartner = state => state.partnerDomain.partner

const getPartner = () => createSelector(
  [selectPartner],
  cse => cse.data,
)

const getPartnerError = () => createSelector(
  [selectPartner],
  cse => cse.error,
)

const getPartnerLoading = () => createSelector(
  [selectPartner],
  cse => cse.loading,
)

const selectCreate = state => state.partnerDomain.create

const getCreatePartner = () => createSelector(
  [selectCreate],
  cse => cse.data,
)

const getCreatePartnerError = () => createSelector(
  [selectCreate],
  cse => cse.error,
)

const getCreatePartnerLoading = () => createSelector(
  [selectCreate],
  cse => cse.loading,
)
const selectUpdate = state => state.partnerDomain.update

const getUpdatePartner = () => createSelector(
  [selectUpdate],
  cse => cse.data,
)

const getUpdatePartnerError = () => createSelector(
  [selectUpdate],
  cse => cse.error,
)

const getUpdatePartnerLoading = () => createSelector(
  [selectUpdate],
  cse => cse.loading,
)
const selectDelete = state => state.partnerDomain.delete

const getDeletePartner = () => createSelector(
  [selectDelete],
  cse => cse.data,
)

const getDeletePartnerError = () => createSelector(
  [selectDelete],
  cse => cse.error,
)

const getDeletePartnerLoading = () => createSelector(
  [selectDelete],
  cse => cse.loading,
)

// for doctor/patient app
const selectPartnerData = state => state.partnerDomain.partnerData

const getPartnerData = () => createSelector(
  [selectPartnerData],
  cse => cse.data,
)

const getPartnerDataError = () => createSelector(
  [selectPartnerData],
  cse => cse.error,
)

const getPartnerDataLoading = () => createSelector(
  [selectPartnerData],
  cse => cse.loading,
)

module.exports = {
  getPartnerList,
  getPartnerListLoading,
  getPartnerListError,
  getPartner,
  getPartnerLoading,
  getPartnerError,
  getCreatePartner,
  getCreatePartnerLoading,
  getCreatePartnerError,
  getUpdatePartner,
  getUpdatePartnerLoading,
  getUpdatePartnerError,
  getDeletePartner,
  getDeletePartnerLoading,
  getDeletePartnerError,

  // for doctor/patient app
  getPartnerData,
  getPartnerDataError,
  getPartnerDataLoading,
}
